import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ACTIONS from "../../../redux/action";
import axios from "../../../shared/axios/axiosProxy";
import {
  getCompanyTaxFormOptions,
  isCompanyTaxForm,
} from "../../searchFlowVersionB/steps/company/CompanyTaxForm.jsx";
import i18n from "../../../utils/i18n";
import classes from "./kftRegTaxForm.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const KftRegTaxForm = ({ onInteractedChange, initialInteracted = false } = {}) => {
  const companyStore = useSelector((state) => state.company_store);
  const dispatch = useDispatch();

  const options = useMemo(() => getCompanyTaxFormOptions(), []);

  // Same "don't trust a stale default as a real pick" rule as CompanyTaxForm — Next
  // stays disabled and no option shows selected until the user actually clicks one.
  const [hasInteracted, setHasInteracted] = useState(initialInteracted);

  useEffect(() => {
    onInteractedChange?.(hasInteracted);
  }, [hasInteracted, onInteractedChange]);

  const selectedValue =
    hasInteracted && isCompanyTaxForm(companyStore.taxform)
      ? companyStore.taxform
      : "";

  const updateTaxForm = useCallback(
    (value) => {
      setHasInteracted(true);
      dispatch(
        ACTIONS.addCompanyInfo({
          id: "taxform",
          data: value,
          stateObject: "company_store",
        }),
      );

      const searchID = companyStore.searchID;
      if (!searchID) {
        return;
      }
      axios
        .patch(
          `/api/search/${searchID}`,
          { taxform: value },
          { headers: { "Content-Type": "application/json" } },
        )
        .catch((error) => {
          console.error(
            "Error saving taxform to searchSchema:",
            error.response?.data || error.message,
          );
        });
    },
    [companyStore.searchID, dispatch],
  );

  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.kftregtaxformtitle")}
              </h1>
              <p className={classes.subtitle}>
                {i18n.t("searchflow.kftregtaxformsubtitle")}
              </p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {options.map((option) => {
                  const isSelected = selectedValue === option.value;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => updateTaxForm(option.value)}
                      aria-pressed={isSelected}
                    >
                      <div className={classes.cardContent}>
                        <div className={classes.cardTitle}>{option.title}</div>
                        <div className={classes.cardSubtitle}>{option.description}</div>
                      </div>
                      <Radio checked={isSelected} />
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KftRegTaxForm;
